exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-1ebac4e2] .el-dialog__title {\n  font-size: 25px;\n  color: #606266;\n}\n[data-v-1ebac4e2] .el-form-item__label {\n  font-family: Arial, Helvetica, sans-serif;\n}\n[data-v-1ebac4e2] .el-dialog__footer {\n  padding-top: 0;\n}\n.select-grade[data-v-1ebac4e2] {\n  width: 100%;\n}\n", ""]);

// exports
